import React from 'react'
import { Outlet } from 'react-router-dom';

function ErrorsLayout() {
  return (
    <div className="w-screen h-screen">
        <Outlet />
    </div>
  )
}

export default ErrorsLayout;
